import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fast-backward-single",
  "use": "fast-backward-single-usage",
  "viewBox": "0 0 5.472 9.859",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.472 9.859\" id=\"fast-backward-single\"><path data-name=\"Path 15042\" d=\"M.174 4.49L4.421.182a.612.612 0 0 1 .87 0 .625.625 0 0 1 0 .879L1.477 4.93 5.291 8.8a.625.625 0 0 1 0 .879.612.612 0 0 1-.87 0L.174 5.369a.642.642 0 0 1 0-.879z\" fill=\"#0f2847\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol